import { useSearchParams } from 'react-router-dom';
import AuditLogTimeline from './AuditLogTimeline';

/** Full audit log page: its filters live in the URL. */
export default function AuditLogPage({ title, fetchAuditLogs }) {
  const [params, setParams] = useSearchParams();

  return (
    <AuditLogTimeline
      width="wide"
      title={title}
      params={params}
      onParamsChange={setParams}
      fetchAuditLogs={fetchAuditLogs}
    />
  );
}
